export default __webpack_public_path__ + "static/assets/med_gel_solid_04_f.722b6c38.png";